/* eslint-disable */
import { paper } from 'paper'

let canvas, path, canvasHeight, canvasWidth, radius, minimumPointDistance

const radiusToWidthRatio = 10.86
const divsor = 8.0
const numberOfPoints = 6
const pointAvoidanceLevel = 4
let firstRun = true

function resetCanvas() {
  firstRun = true
}

function setUpCanvas() {
  canvas = document.getElementById('paper-canvas')
  if (firstRun) {
    paper.setup(canvas)
    firstRun = false
  }

  paper.project.activeLayer.removeChildren()
  path = new paper.Path()
  path.strokeColor = 'transparent'
  canvasWidth = canvas.clientWidth
  canvasHeight = canvas.clientHeight
  radius = canvasWidth / radiusToWidthRatio
  minimumPointDistance = canvasWidth / pointAvoidanceLevel
}

function drawCircles(callback, type) {
  setUpCanvas()

  let refreshes = 0

  for (let p = 0; p < numberOfPoints; p++) {
    const newPoint = new paper.Point(getRandomX(), getRandomY())

    const distance = newPoint.getDistance(path.getNearestPoint(newPoint))

    if (distance < minimumPointDistance && refreshes < 100) {
      refreshes++
      p--
    } else {
      path.add(newPoint)
      refreshes = 0
    }
  }

  path.closed = true
  path.smooth({ type: 'catmull-rom', factor: 0.5 })

  const length = path.length
  const amount = length / divsor

  const delay = 10
  let i = 0.0

  const drawFunction = setInterval(function () {
    const offset = (i / amount) * length
    const point = path.getPointAt(offset)

    const circle = new paper.Path.Circle({
      center: point,
      radius,
      strokeWidth: 0.5,
      strokeColor: new paper.Color(1, 1, 1, 0.8),
    })

    i++
    if (i >= amount - 0.5) {
      clearInterval(drawFunction)
      sleep(100).then(() => {
        if (type == 'jpg') callback(canvas.toDataURL('image/jpeg'))
        if (type == 'svg') {
          var exportUrl =
            'data:image/svg+xml;utf8,' +
            encodeURIComponent(paper.project.exportSVG({ asString: true }))
          callback(exportUrl)
        }
      })
    }
  }, delay)
}

function getRandomX() {
  const margin = canvasWidth / 15 + radius * 2
  return Math.min(
    Math.max(margin, Math.random() * canvasWidth),
    canvasWidth - margin
  )
}

function getRandomY() {
  const margin = canvasHeight / 15 + radius * 2
  return Math.min(
    Math.max(margin, Math.random() * canvasHeight),
    canvasHeight - margin
  )
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export { drawCircles, resetCanvas }
